import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import { initialiseGoogleAnalytics } from './analytics';
import { App } from './App';
import { GlobalStyle } from './styles';

initialiseGoogleAnalytics();

createRoot(document.querySelector<HTMLDivElement>('#app')!).render(
  <StrictMode>
    <GlobalStyle />
    <App />
  </StrictMode>,
);
